import { render, staticRenderFns } from "./SimpleModelDataTable.vue?vue&type=template&id=38a00420&lang=pug&"
import script from "./SimpleModelDataTable.vue?vue&type=script&lang=js&"
export * from "./SimpleModelDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SimpleModelDataTable.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib'
import { VPagination } from 'vuetify/lib'
installComponents(component, {
  VDataTable,
  VPagination,
})
